import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.80485 0.303505C3.91263 0.200915 4.08737 0.200915 4.19515 0.303505L7.66861 3.60977C7.84247 3.77526 7.71934 4.05822 7.47346 4.05822H0.526537C0.280662 4.05822 0.157527 3.77526 0.331387 3.60977L3.80485 0.303505Z"
      fill="#151718"
    />
  </svg>
);

const ArrowUpIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ArrowUpIcon;
